export const messages = {
  en: {
    examineStaffValue: {
      search: {
        title: 'Search Conditions',
        staffName: 'Please select staff name',
        projectName: 'Please select examine project'
      },
      list: {
        title: 'Examine Records'
      },
      table: {
        year: 'Year',
        staffId: 'Staff ID',
        staffName: 'Staff Name',
        projectName: 'Examine Project',
        weight: 'Weight',
        examineValue: 'Score',
        actualScore: 'Actual Score',
        ownerName: 'Rater',
        roomName: 'Room',
        createTime: 'Rating Time'
      },
      fetchError: 'Failed to fetch examine records'
    }
  },
  zh: {
    examineStaffValue: {
      search: {
        title: '查询条件',
        staffName: '请选择员工名称',
        projectName: '请选择考核项目'
      },
      list: {
        title: '考核记录'
      },
      table: {
        year: '年度',
        staffId: '员工ID',
        staffName: '员工名称',
        projectName: '考核项目',
        weight: '权重',
        examineValue: '评分',
        actualScore: '实际得分',
        ownerName: '评分人',
        roomName: '房屋',
        createTime: '评分时间'
      },
      fetchError: '获取考核记录失败'
    }
  }
}